// user.js

export const USER_UPDATE = 'USER_UPDATE';
export const USER_CREATE= 'USER_CREATE';
export const LIST_USER = 'LIST_USER';
export const DELETE_LIST_USER = 'DELETE_LIST_USER';

export function listUser(index){
  return {
    type: LIST_USER,
    index
  }
}

export function deleteListUser() {
  return {
    type: DELETE_LIST_USER,
  }
}

export function userCreate(object){
  return {
    type: USER_CREATE,
    object
  };
}

export function userUpdate(value){
  return {
    type: USER_UPDATE,
    value
  }
}

const initialState = {
  user: null
};

export default function reducer(state = initialState, action){
    console.log('state', state)
    console.log('action', action)
    switch (action.type){
    case USER_CREATE:
      return Object.assign(
        {},
        state,
        {
          user: action.object
        }
      );
    case USER_UPDATE:
      return Object.assign(
        {},
        state,
        {user: action.value}
      );
    case LIST_USER:
      return Object.assign(
        {},
        state,
        {
          user: [
            ...state.list.slice(0, action.index),
            Object.assign({}, state.list[action.index], {done: !state.list[action.index].done}),
            ...state.list.slice(action.index+1)
          ]
        }
      );
    case DELETE_LIST_USER:
      return Object.assign(
        {},
        state,
        {
          user: null
        }
      );
    default:
      return state;
    }
}